
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";




const ChannelList = () => {

    const [channels, setchannels] = useState([]);
    const [deselect, setDselect] = useState("");
    const [userId, setUserId] = useState("");
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [query, setQuery] = useState("");
    useEffect(() => {
        axiosConfig.get("/channelList").then((rsp) => {
            setchannels(rsp.data.channels);
            console.log(rsp.data.channels[0]);
        }, (err) => { });


    }, []);

    const activate_channel = (id) => {

        const obj = { id: id };
        axiosConfig.get("/activate_channel/" + id + "/", obj).then((rsp) => {
            window.location.reload(false);
        }, (err) => {
        });
    };
    const activate_channel_d = (id) => {

        const obj = { id: id };
        axiosConfig.get("/activate_channel_d/" + id + "/", obj).then((rsp) => {
            window.location.reload(false);
        }, (err) => {
        });
    };
    const deactivate_channel_d = (id) => {

        const obj = { id: id };
        axiosConfig.get("/deactivate_channel_d/" + id + "/", obj).then((rsp) => {
            window.location.reload(false);
        }, (err) => {
        });
    };
    const deactivate_channel = (id) => {

        const obj = { id: id };
        axiosConfig.get("/deactivate_channel/" + id + "/", obj).then((rsp) => {
            window.location.reload(false);
        }, (err) => {
        });
    };
    const deletechannel = (id) => {

        const obj = { id: id };
        axiosConfig.post("/channel/delete", obj).then((rsp) => {
            window.location.reload(false);
        }, (err) => {
        });
    };

    const Search = (data) => {
        return data.filter(
            (item) =>
                item.channel_name.toLowerCase().includes(query.toLowerCase()) 
        );
    };

    const handleChange = (event, channel_id) => {

        if (event.target.checked) {
            //console.log('✅ Checkbox is checked');
            const obj = { channel_id: channel_id, deselect: 'deselect' };
            axiosConfig.post("/channel/deselect", obj).then((rsp) => {
                window.location.reload(false);
            }, (err) => {
            });


        } else {
            //console.log('⛔️ Checkbox is NOT checked');
            const obj = { channel_id: channel_id, deselect: '' };
            axiosConfig.post("/channel/deselect", obj).then((rsp) => {
                window.location.reload(false);
            }, (err) => {
            });



        }
        setIsSubscribed(current => !current);

        console.log(event.target.checked);


        

    };

    function exportToCsv(filename, rows) {
        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = row[j] === null ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                };
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    finalVal += ',';
                finalVal += result;
            }
            return finalVal + '\n';
        };
        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }
        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    var getCSV = (scsv) => {
        exportToCsv("deployed_"+new Date().toLocaleString()+".csv", scsv)
    }

    



    return (
        <div><Header title="Channels" />
            <MainMenu menu="ChannelList" />
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">



                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">Channel List</div></div>
                                                            <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search by Channel Name" onChange={e => setQuery(e.target.value)} />
                                                            </div>

                                                        </div>
                                                        {/* <a class="btn btn-primary" href="/channel/create">Create New</a> */}
                                                        {/* <button class="btn btn-success pull-right" onClick={exportchannels}>Export</button> */}
                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            <table class="table display nowrap table-striped table-bordered">
                                                                <thead style={{ position: "sticky", top: -1, zIndex: 1 ,backgroundColor:"white"}}>
                                                                    <tr>
                                                                        <th>Channel</th>
                                                                        <th>Dashboard</th>
                                                                        <th>Reporting</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {Search(channels).map((channel) =>
                                                                        <tr key={channel.id}>
                                                                            <td><img class="img-fluid" alt="" style={{ maxWidth: "3rem" }} src={"../../channels/logos/" + channel.logo} />{channel.channel_name}</td>
                                                                            
                                                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                                                {channel.active==1?
                                                                                <button class="offset-1 btn btn-danger" onClick={() => { if (window.confirm('Deactivate the item?')) { deactivate_channel(channel.id) }; }} >Deactivate</button>:
                                                                                <button class="offset-1 btn btn-success" onClick={() => { if (window.confirm('Activate the item?')) { activate_channel(channel.id) }; }} >Activate</button>
                                                                                }
                                                                            </td>
                                                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                                                {channel.active_d==1?
                                                                                <button class="offset-1 btn btn-danger" onClick={() => { if (window.confirm('Deactivate the item?')) { deactivate_channel_d(channel.id) }; }} >Deactivate</button>:
                                                                                <button class="offset-1 btn btn-success" onClick={() => { if (window.confirm('Activate the item?')) { activate_channel_d(channel.id) }; }} >Activate</button>
                                                                                }
                                                                            </td>
                                                                            


                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                            
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >





                            </div>
                        </div>


                        <br />



                        <br />


                    </div>
                </div>

            </div>
        </div>
    )

}
export default ChannelList;